import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

const PeakCheckInChart = ({ data = {} }) => {
  const { t } = useTranslation();

  const durationKeys = ["2hour", "4hour", "6hour", "overnight"];

  const { categories, series, isEmpty } = useMemo(() => {
    const hourlyData = data?.hourlyData || [];
    const allZero =
      hourlyData.length === 0 ||
      hourlyData.every((h) => !h.total || h.total === 0);

    if (allZero) {
      return {
        categories: Array.from({ length: 24 }, (_, i) => `${i}:00`),
        series: durationKeys.map((d) => ({
          name: t(`peakCheckIn.durations.${d}`),
          data: new Array(24).fill(0),
        })),
        isEmpty: true,
      };
    }

    const categories = hourlyData.map((h) => h.hourLabel);
    const series = durationKeys.map((d) => ({
      name: t(`peakCheckIn.durations.${d}`),
      data: hourlyData.map((h) => h.durations?.[d]?.count || 0),
    }));

    return { categories, series, isEmpty: false };
  }, [data, t]);

  const options = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 4,
      },
    },
    xaxis: {
      categories,
      title: { text: t("peakCheckIn.xAxis") },
    },
    yaxis: {
      title: { text: t("peakCheckIn.yAxis") },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
    },
    colors: ["#009298", "#003e70", "#71da61", "#9c1de7"],
    title: {
      text: t("peakCheckIn.title"),
      align: "center",
      style: { color: "#444" },
    },
  };

  return (
    <div className="mt-4">
      <h6 className="fw-bold mb-2" style={{ color: "#333" }}>
        {t("peakCheckIn.title")}
      </h6>

      <ReactApexChart options={options} series={series} type="bar" height={300} />

      {isEmpty && (
        <div className="text-center text-muted mt-2" style={{ fontSize: "14px" }}>
          {t("peakCheckIn.noData")}
        </div>
      )}
    </div>
  );
};

export default PeakCheckInChart;
